import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http'; //eliminar cuando se implemente lo correspondiente 
import { Subscription } from 'rxjs';
import { PlanificadorService } from '../../models/control.service';
import { createChart, LineSeries, ColorType, CrosshairMode, IChartApi } from 'lightweight-charts';
import { DiversificadorService } from 'src/app/services/diversificador.services';
import { GestionService } from 'src/app/services/gestion.services';
import { OptimalWallet } from 'src/app/interface/OptimalWallet';
import { BrokerService } from 'src/app/services/broker.services';
import { TemaService } from 'src/app/services/tema.services';
import { ChangeDetectorRef } from '@angular/core';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { SseService } from 'src/app/services/SseService';

@Component({
  selector: 'app-grafica-rendimiento',
  templateUrl: './grafica-rendimiento.component.html',
  styleUrl: './grafica-rendimiento.component.scss'
})
export class GraficaRendimientoComponent implements OnInit, OnChanges, OnDestroy {
  // LWC chart instances
  private charts: Map<string, IChartApi> = new Map();
  private series0Map: Map<string, any> = new Map(); // Valor Liquidativo
  private series1Map: Map<string, any> = new Map(); // Retroceso
  private series2Map: Map<string, any> = new Map(); // Retroceso %
  private resizeObservers: Map<string, ResizeObserver> = new Map();
  private tooltipEls: Map<string, HTMLElement> = new Map();
  private dataStoreMap: Map<string, { d0: any[]; d1: any[]; d2: any[] }> = new Map();
  private dblClickHandlers: Map<string, (e: MouseEvent) => void> = new Map();
  public carteraOptima = new Subscription;
  public optimaSub = new Subscription;
  public formdataSub = new Subscription;
  public divSubIdcarteras = new Subscription;
  public divOptimaWalletSub = new Subscription;
  public gesSuboptima = new Subscription;
  public brokSuboptima = new Subscription;
  public gestLiqValSub = new Subscription;
  public divLiqValSub = new Subscription;
  public plaLiqValSub = new Subscription;
  public exeGraBrok = new Subscription;
  public divIdCarteras: number[] = [];
  public dataLine1: any;
  public retroceso: any;
  public retrocesopor : any;
  public divdataLine1: any;
  public divretroceso: any;
  public divretrocesopor: any;
  public carteraGestor: any;
  public carteraBroker:any;
  public carteraDiv: any;
  public divOptimaWallet: OptimalWallet;
  public urlDiv:string;
  public urlGestor: string;
  public urlBroker:string;
  public url='';
  @Input() selectedTab: number = 0;
  public modeloIsLoad: boolean = false;
  @Input() modelo: boolean = false;
  @Input() isPlanificador: boolean = false;
  @Input() isGestion: boolean = false;
  @Input() isBroker: boolean = false;
  // Origen de tbl_rendimientos a leer; sin valor el backend devuelve RECALCULAR
  @Input() origen: string | null = null;
  public index: any;
  public indexDiv: any;
  public indexGest: any;
  public indexBrok: any;
  public Modelformdata: any;
  public otimawallet: OptimalWallet;
  gestdataLine1: any;
  gestretroceso: any;
  gestretrocesopor: any;
  brokdataLine1: any;
  brokretroceso: any;
  brokretrocesopor: any;
  backgroundColor: string = '';
  color: string = '';
  public subDarktema: Subscription;
  @ViewChild(CdkVirtualScrollViewport, { static: false }) viewportGraficas!: CdkVirtualScrollViewport;
  public isshow: boolean=false;
  public divIsShow: boolean=false;
  public subIsShow: Subscription;
  public subdivIsShow: Subscription;

  constructor(private _httcliet: HttpClient,
    private _controlService: PlanificadorService,
    private _diverisificadorsv: DiversificadorService,
    private _gestorsv: GestionService,
    private _brokersv: BrokerService,
    private _temaService: TemaService,
    private _sseService: SseService,
    private cdr: ChangeDetectorRef) {

  }


  ngOnInit(): void {

    this.optimaSub = this._controlService.valoptimaWallet$.subscribe({
      next: (data: any) => {
        this.otimawallet = data;
      }
    });

    this.carteraOptima = this._controlService.isLoadCartera$.subscribe(value => {
      if (value) {
        this.modeloIsLoad=value;
        this.obtenerModelo();
      }else{

        this.dataLine1 = [];
        this.retroceso = [];
        this.retrocesopor = [];
        this.cdr.detectChanges();

      }
    });
    
    this.plaLiqValSub = this._controlService.valexecuteGrap$.subscribe({
      next: (data: any)=>{
        console.log("se ejecuto grafica de planificador data", data);
        if(data){
          console.log("se ejecuto grafica de planificador data", data);
          console.log(" this.Modelformdata.idModelo ", this.Modelformdata);
          const valRiesgoParam = (this.Modelformdata && this.Modelformdata.valorRiesgo !== undefined && this.Modelformdata.valorRiesgo !== null)
            ? this.Modelformdata.valorRiesgo
            : (this.otimawallet && this.otimawallet.riesgo !== undefined ? this.otimawallet.riesgo : '');
          const idModeloParam = (this.Modelformdata && this.Modelformdata.idModelo) ? this.Modelformdata.idModelo : (this.otimawallet && this.otimawallet.idModelo ? this.otimawallet.idModelo : '');
          this.url = 'obtenerDatosGraficaRendimientos?idcartera=' + idModeloParam + '&idcarteras=' + '&valorriesgo=' + encodeURIComponent(String(valRiesgoParam))
            + (this.origen ? '&origen=' + encodeURIComponent(this.origen) : '');
          console.log(" this.url this.url ", this.url);
       
          console.log("se ejecuto grafica de planificador");
          if(this.isshow){
            this.fetchData(this.url, 'container');
          }
          this._controlService.updateExecuteGrap(false);
        }else{console.log("estaVACIO")}
      
      }

    });

    this.subIsShow = this._controlService.valisshoW$.subscribe({
      next: (data: any)=>{
        this.isshow =data;
        console.log("this.subIsShow = this._controlService.valisshoW$.subscribe({ ",  this.isshow);
        this.cdr.detectChanges();
      }
      
      });

    //---------------------------- DIVERSIFICADOR ---------------------------
    this.divOptimaWalletSub = this._diverisificadorsv.valDivOptimaWallet$.subscribe({
      next: (data: OptimalWallet) => {
        this.divOptimaWallet = data;
      }
    });
    this.divSubIdcarteras = this._diverisificadorsv.valDivIdeCarteras$.subscribe({
      next: (data: any) => {
        console.log(data);
        //this.divIsShow=false;
        
        let datos = data.filter((id: number) => id !== 0).join(',');
        if (this.isPlanificador) {

          if (datos !== '') {
            this.carteraDiv = datos;
         
            this.urlDiv = 'obtenerDatosGraficaRendimientos?idcartera=0&idcarteras=' + this.carteraDiv + '&valorriesgo=' + encodeURIComponent(String(this.divOptimaWallet?.riesgo ?? ''));

          } else if (Array.isArray(this.divdataLine1)) {
            console.log("entro a ejecutar Grafica diversificador: ", datos);
            this.carteraDiv = '';
            console.log("se limpia la grafica", this.divIsShow);
            this._diverisificadorsv.updateDivExecuteGrap(false);
            this.cdr.detectChanges();
          }
        }
      }
    });
    this.divLiqValSub = this._diverisificadorsv.valDivExecuteGrap$.subscribe({
      next: (data: any) => {
        if (this.carteraDiv !='' && data) {
          this._diverisificadorsv.updatedivIsShow(true);
          this.urlDiv = 'obtenerDatosGraficaRendimientos?idcartera=0&idcarteras=' + this.carteraDiv + '&valorriesgo=' + encodeURIComponent(String(this.divOptimaWallet?.riesgo ?? ''));
          console.log(this.urlDiv);
          console.log("se ejecuto grafica de Diversificador")
          this._diverisificadorsv.updateDivExecuteGrap(false);
          this.fetchData(this.urlDiv, 'container2');
        }
      }
    });
    this.subdivIsShow = this._diverisificadorsv.valdivIsShow$.subscribe({
      next: (data: any)=>{
        this.divIsShow = data;
        console.log("desde observable divIsShow", this.divIsShow);
      }
    })
    //---------------- GESTOR ---------------------
    this.gesSuboptima = this._gestorsv.valgestOptimaWallet$.subscribe({
      next: (data: any) => {
        this.carteraGestor = data;
        this.urlGestor = 'obtenerDatosGraficaRendimientos?idcartera=' + this.carteraGestor.idcartera + '&idcarteras=' + '&valorriesgo=' + encodeURIComponent(String(this.carteraGestor.riesgo ?? ''));//usar esta ruta para gestor/broker en vez de id modelo colocar id carter
      }
    });
    this.gestLiqValSub = this._gestorsv.valgestExecuteGrap$.subscribe({
      next: (data: any) => {
        if (this.carteraGestor.idcartera && data) {
          console.log("calculando Grafica Rendimiento Gestor XXXXXX", this.carteraGestor.idcartera);
          this.urlGestor = 'obtenerDatosGraficaRendimientos?idcartera=' + this.carteraGestor.idcartera + '&idcarteras=' + '&valorriesgo=' + encodeURIComponent(String(this.carteraGestor.riesgo ?? ''));//usar esta ruta para gestor/broker en vez de id modelo colocar id cartera
          console.log(this.urlGestor);
          console.log("se ejecuto grafica de valgestExecuteGrap")
          this._gestorsv.updateGestExecuteGrap(false);
          this.fetchData(this.urlGestor, 'container3');
        }

      }
    });
    //---------------- BROKER ---------------------
    this.brokSuboptima = this._brokersv.valBrokOptimaWallet$.subscribe({
      next: (data: any) => {
        this.carteraBroker = data;
        if (data.idcartera) {
          console.log("calculando Grafica Rendimiento BROKER");
          this.urlBroker = 'obtenerDatosGraficaRendimientos?idcartera=' + data.idcartera + '&idcarteras=' + '&valorriesgo=' + encodeURIComponent(String(data.riesgo ?? ''));//usar esta ruta para gestor/broker en vez de id modelo colocar id cartera
          this.fetchData(this.urlBroker, 'container4');
        }
      }
    });
    this.exeGraBrok = this._brokersv.valBrokExecuteGrap$.subscribe({
      next: (data: any)=>{
        if(this.carteraBroker.idcartera && data){
          console.log("calculando Grafica Rendimiento BROKER");
          this.urlBroker = 'obtenerDatosGraficaRendimientos?idcartera=' + this.carteraBroker.idcartera + '&idcarteras=' + '&valorriesgo=' + encodeURIComponent(String(this.carteraBroker.riesgo ?? ''));//usar esta ruta para gestor/broker en vez de id modelo colocar id cartera
          this.fetchData(this.urlBroker, 'container4');
          this._brokersv.updateBrokExecuteGrap(false);
          console.log("se ejecuto grafica de BROKER")
        }
      }
    });
    this.subDarktema = this._temaService.valDarkTheme.subscribe({
      next: (data: any) => {
        if (data) {
          console.log("grafica tema oscuro");
          this.backgroundColor = '#333';
          this.color = '#ffffff';
        } else {
          console.log("grafica tema claro");
          this.backgroundColor = '#ffffff';
          this.color = '#000000';
        }
        this.applyThemeToAllCharts();
      }
    });

  }

  obtenerModelo(){
    this.formdataSub = this._controlService.getModelMercat().subscribe(datos => {
      this.Modelformdata = datos;
      console.log("this.formdataSub = this._controlService.getModelMercat()",datos)
    });
    if (this.Modelformdata.idModelo) {
      const valRiesgoParam2 = (this.Modelformdata && this.Modelformdata.valorRiesgo !== undefined && this.Modelformdata.valorRiesgo !== null)
        ? this.Modelformdata.valorRiesgo
        : (this.otimawallet && this.otimawallet.riesgo !== undefined ? this.otimawallet.riesgo : '');
      this.url = 'obtenerDatosGraficaRendimientos?idcartera=' + this.Modelformdata.idModelo + '&idcarteras=' + '&valorriesgo=' + encodeURIComponent(String(valRiesgoParam2));
      console.log("if (this.Modelformdata.idModelo) {", this.url);
    } else { console.log("no se ejecuta grafica");     }
  }

  async fetchData(url: any, div: any) {
    console.log("fetchData url: ", url+ " div: ", div);
    try {
      //const Datos = await this._httcliet.get<any>(url).toPromise();
      const Datos= await this._sseService.apiGetNew(url).toPromise();
      if (this.modelo) {
        this.dataLine1 = JSON.parse(Datos.data);
        this.retroceso = JSON.parse(Datos.retroceso);
        this.retrocesopor = JSON.parse(Datos.retrocesopor);
        if (document.getElementById('container')) {
          await this.createChart(this.dataLine1, this.retroceso, this.retrocesopor, 'container');
        }
      } else if (this.isPlanificador) {
        this.divdataLine1 = JSON.parse(Datos.data);
        this.divretroceso = JSON.parse(Datos.retroceso);
        this.divretrocesopor = JSON.parse(Datos.retrocesopor);
        if (document.getElementById('container2')) {
          await this.createChart(this.divdataLine1, this.divretroceso, this.divretrocesopor, 'container2');
        }

      } else if (this.isGestion) {
        this.gestdataLine1 = JSON.parse(Datos.data);
        this.gestretroceso = JSON.parse(Datos.retroceso);
        this.gestretrocesopor = JSON.parse(Datos.retrocesopor);
        if (document.getElementById('container3')) {
          await this.createChart(this.gestdataLine1, this.gestretroceso, this.gestretrocesopor, 'container3');
        }
      } else if (this.isBroker) {
        this.brokdataLine1 = JSON.parse(Datos.data);
        this.brokretroceso = JSON.parse(Datos.retroceso);
        this.brokretrocesopor = JSON.parse(Datos.retrocesopor);
        if (document.getElementById('container4')) {
          await this.createChart(this.brokdataLine1, this.brokretroceso, this.brokretrocesopor, 'container4');
        }

      }
    } catch (error) {
      console.error('Error al recuperar datos:', error);
    }
  }

  async createChart(data: any, retroceso: any, retrocesopor: any, div: string) {
    const container = document.getElementById(div);
    if (!container) return;

    // Convert data from [[ms, value], ...] to LWC format
    const d0 = this.convertData(data);
    const d1 = this.convertData(retroceso);
    const d2 = this.convertData(retrocesopor);

    // Destroy any existing chart for this container
    this.destroyChartForDiv(div);

    const isDark = this.backgroundColor === '#333';
    const c = this.getColors(isDark);

    // Create main chart
    const chart = createChart(container, {
      layout: {
        background: { type: ColorType.Solid, color: c.bg },
        textColor: c.text,
      },
      grid: {
        vertLines: { color: c.grid },
        horzLines: { color: c.grid },
      },
      crosshair: {
        mode: CrosshairMode.Normal,
      },
      timeScale: {
        borderColor: c.border,
        timeVisible: true,
        minBarSpacing: 0.1,
      },
      rightPriceScale: {
        borderColor: c.border,
        visible: true,
        scaleMargins: { top: 0.1, bottom: 0.02 },
      },
    });

    // Pane 0 (main): Valor Liquidativo
    const s0 = chart.addSeries(LineSeries, {
      color: '#2196f3',
      lineWidth: 2,
      priceLineVisible: false,
      lastValueVisible: true,
      title: '',
    });
    s0.setData(d0);

    // Pane 1: Retroceso
    const pane1 = (chart as any).addPane({ height: 80 });
    const s1 = pane1.addSeries(LineSeries, {
      color: '#ef5350',
      lineWidth: 1,
      priceLineVisible: false,
      lastValueVisible: true,
      title: '',
    });
    s1.setData(d1);

    // Pane 2: Retroceso %
    const pane2 = (chart as any).addPane({ height: 80 });
    const s2 = pane2.addSeries(LineSeries, {
      color: '#26a69a',
      lineWidth: 1,
      priceLineVisible: false,
      lastValueVisible: true,
      title: '',
    });
    s2.setData(d2);

    // Store instances
    this.charts.set(div, chart);
    this.series0Map.set(div, s0);
    this.series1Map.set(div, s1);
    this.series2Map.set(div, s2);
    this.dataStoreMap.set(div, { d0, d1, d2 });

    // Tooltip DOM element
    container.style.position = 'relative';
    const tooltip = document.createElement('div');
    tooltip.style.cssText = 'position:absolute;top:4px;left:4px;z-index:10;pointer-events:none;' +
      'background:rgba(0,0,0,0.72);color:#fff;padding:6px 10px;border-radius:4px;font-size:12px;display:none;line-height:1.6;';
    container.appendChild(tooltip);
    this.tooltipEls.set(div, tooltip);


    const fmtTime = (t: any): string => {
      if (!t) return '';
      if (typeof t === 'string') return t;
      if (typeof t === 'object' && t.year != null)
        return `${t.year}-${String(t.month).padStart(2, '0')}-${String(t.day).padStart(2, '0')}`;
      if (typeof t === 'number') return new Date(t * 1000).toISOString().slice(0, 10);
      return '';
    };

    chart.subscribeCrosshairMove((param: any) => {
      if (!param || !param.point || param.point.x < 0 || param.point.y < 0) {
        tooltip.style.display = 'none';
        return;
      }
      const time = chart.timeScale().coordinateToTime(param.point.x);
      const timeKey = fmtTime(time);
      if (!timeKey) { tooltip.style.display = 'none'; return; }

      const stored = this.dataStoreMap.get(div);
      const val0 = stored?.d0.find((x: any) => x.time === timeKey);
      const val1 = stored?.d1.find((x: any) => x.time === timeKey);
      const val2 = stored?.d2.find((x: any) => x.time === timeKey);

      let html = `<div style="margin-bottom:2px;font-weight:bold;">${timeKey}</div>`;
      if (val0) html += `<div><span style="color:#2196f3">●</span> Val. Liq: <b>${Number(val0.value).toFixed(4)}</b></div>`;
      if (val1) html += `<div><span style="color:#ef5350">●</span> Retroceso: <b>${Number(val1.value).toFixed(4)}</b></div>`;
      if (val2) html += `<div><span style="color:#26a69a">●</span> Retroceso %: <b>${Number(val2.value).toFixed(4)}</b></div>`;

      tooltip.innerHTML = html;
      tooltip.style.display = 'block';
    });

    // Double-click → scroll to that date
    const dblHandler = (e: MouseEvent) => {
      const rect = container.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const time = chart.timeScale().coordinateToTime(x);
      if (time) {
        const dateStr = fmtTime(time);
        if (dateStr) this.scrollToFirstDate(dateStr, div);
      }
    };
    container.addEventListener('dblclick', dblHandler);
    this.dblClickHandlers.set(div, dblHandler);

    // ResizeObserver
    const ro = new ResizeObserver((entries) => {
      const entry = entries[0];
      const w = entry?.contentRect?.width || container.clientWidth;
      const h = entry?.contentRect?.height || container.clientHeight;
      if (w > 0 && h > 0) { try { chart.resize(w, h); } catch {} }
    });
    ro.observe(container);
    this.resizeObservers.set(div, ro);

    chart.timeScale().fitContent();
  }

  private convertData(raw: any[]): any[] {
    if (!Array.isArray(raw)) return [];
    return raw
      .filter((p: any) => Array.isArray(p) && p.length >= 2 && Number.isFinite(Number(p[1])))
      .map((p: any) => ({ time: new Date(Number(p[0])).toISOString().slice(0, 10), value: Number(p[1]) }))
      .sort((a: any, b: any) => a.time.localeCompare(b.time))
      .reduce((acc: any[], item: any) => {
        if (!acc.length || acc[acc.length - 1].time !== item.time) acc.push(item);
        return acc;
      }, []);
  }

  setRange(div: string, period: string): void {
    const chart = this.charts.get(div);
    if (!chart) return;
    if (period === 'all') {
      const stored = this.dataStoreMap.get(div);
      if (stored && stored.d0.length) {
        const first = stored.d0[0].time as string;
        const last = stored.d0[stored.d0.length - 1].time as string;
        try { chart.timeScale().setVisibleRange({ from: first as any, to: last as any }); } catch {}
      } else {
        chart.timeScale().fitContent();
      }
      return;
    }
    const stored = this.dataStoreMap.get(div);
    if (!stored || !stored.d0.length) return;
    const last = stored.d0[stored.d0.length - 1].time as string;
    const days = period === '1M' ? 30 : period === '3M' ? 90 : period === '6M' ? 180 : 365;
    const fromDate = new Date(last);
    fromDate.setDate(fromDate.getDate() - days);
    const from = fromDate.toISOString().slice(0, 10);
    try { chart.timeScale().setVisibleRange({ from: from as any, to: last as any }); } catch {}
  }

  private destroyChartForDiv(div: string): void {
    const ro = this.resizeObservers.get(div);
    if (ro) { ro.disconnect(); this.resizeObservers.delete(div); }
    const container = document.getElementById(div);
    const handler = this.dblClickHandlers.get(div);
    if (container && handler) container.removeEventListener('dblclick', handler);
    this.dblClickHandlers.delete(div);
    const tooltip = this.tooltipEls.get(div);
    if (tooltip?.parentElement) tooltip.parentElement.removeChild(tooltip);
    this.tooltipEls.delete(div);
    const chart = this.charts.get(div);
    if (chart) { try { chart.remove(); } catch {} this.charts.delete(div); }
    this.series0Map.delete(div);
    this.series1Map.delete(div);
    this.series2Map.delete(div);
    this.dataStoreMap.delete(div);
  }

  private getColors(isDark: boolean) {
    return {
      bg: isDark ? '#1e222d' : '#ffffff',
      text: isDark ? '#d1d4dc' : '#000000',
      grid: isDark ? '#2a2e39' : '#e6e6e6',
      border: isDark ? '#3a3f4b' : '#ccd6eb',
    };
  }

  private applyThemeToAllCharts(): void {
    const isDark = this.backgroundColor === '#333';
    const c = this.getColors(isDark);
    this.charts.forEach((chart) => {
      chart.applyOptions({
        layout: {
          background: { type: ColorType.Solid, color: c.bg },
          textColor: c.text,
        },
        grid: {
          vertLines: { color: c.grid },
          horzLines: { color: c.grid },
        },
      });
    });
  }

  scrollToFirstDate(date: string, div?: string): void {
    const divs = div ? [div] : Array.from(this.charts.keys());
    divs.forEach(d => {
      const chart = this.charts.get(d);
      if (!chart) return;
      const stored = this.dataStoreMap.get(d);
      if (!stored || !stored.d0.length) return;
      const last = stored.d0[stored.d0.length - 1].time as string;
      try { chart.timeScale().setVisibleRange({ from: date as any, to: last as any }); } catch {}
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("DESDE GRAFICA RENDIMIENTO ONCHANGE this.selectedTab" , this.selectedTab);
    this.obtenerModelo();
    //if(this.selectedTab === 3 && this.modeloIsLoad){
    if (this.selectedTab === 3) {
      // console.log("estamos en grafica rendimiento y se cargo modelo ", this.modeloIsLoad);
      if (this.modelo) { 
        if(this.Modelformdata.idModelo){
          console.log(" this.url this.url ", this.url);
          console.log("se crea grafica this.Modelformdata.idModelo", this.Modelformdata.idModelo)
          this.fetchData(this.url, 'container');
        }
      }
      if (this.isPlanificador && this.divIsShow) { 
        if(this.carteraDiv !=''){
          console.log("this.isPlanificador ", this.isPlanificador );
          console.log("this.divIsShow",this.divIsShow);
          this.fetchData(this.urlDiv, 'container2');
        }
      }
      if (this.isGestion) { 
        if (this.carteraGestor.idcartera){
          this.fetchData(this.urlGestor, 'container3');
         }
        }
      if (this.isBroker) { 
        if(this.carteraBroker.idcartera){
          this.fetchData(this.urlBroker, 'container4');
        }


       }
    }
  }


  ngOnDestroy(): void {
    // Destroy all LWC charts
    Array.from(this.charts.keys()).forEach(div => this.destroyChartForDiv(div));

    this.carteraOptima.unsubscribe();
    this.optimaSub.unsubscribe();
    this.formdataSub.unsubscribe();
    this.divSubIdcarteras.unsubscribe();
    this.divOptimaWalletSub.unsubscribe();
    this.gesSuboptima.unsubscribe();
    this.subDarktema.unsubscribe();
    this.brokSuboptima.unsubscribe();
    this.plaLiqValSub.unsubscribe();
    this.exeGraBrok.unsubscribe();
    this.subIsShow.unsubscribe();
    this.subdivIsShow.unsubscribe();
  }

}
